<!-- eslint-disable @intlify/vue-i18n/no-missing-keys -->
<script setup lang="ts">
import {
  IMediaCenterSelection,
  MediaCenterAllowedExtensions,
  MediaCenterSubCategory,
} from "@/helpers/mediaCenter.type";
import { triggerMediaCenterOpen } from "@/helpers/mediaCenterUtil";
import { useAppStore } from "@/store/app";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const store = useAppStore();
const emit = defineEmits(["update:value"]);

const props = defineProps({
  element: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  slideIndex: {
    type: Number,
    required: true,
  },
  value: {
    type: String,
    required: true,
  },
  mediaCenterSubCategory: {
    type: String as () => MediaCenterSubCategory,
    required: true,
  },
});

const handleMediaCenterSelection = (data: IMediaCenterSelection) => {
  if (!data?.url) return;
  emit("update:value", data.url);
  (props.element as any).url = data.url;
  store.anyUnsavedChanges = true;
  store.addToHistory();
};

const onInputClick = (e: Event) => {
  e.preventDefault();

  triggerMediaCenterOpen({
    appHandshake: store.appHandshake,
    settings: {
      allowedExtensions: [MediaCenterAllowedExtensions.IMAGE],
      subCategory: props.mediaCenterSubCategory,
    },
    onSelect: handleMediaCenterSelection,
  });
};
</script>

<template>
  <div>
    <label
      v-if="!('url' in props.element)"
      :for="`image-upload-${props.element.id || props.element.uuid}-${props.index}`"
      class="hidden"
    >
    </label>
    <input
      v-if="!props.element?.url?.length"
      :id="`image-upload-${props.element.id || props.element.uuid}-${props.index}`"
      type="file"
      class="form-control"
      :placeholder="t('common.imagePlaceholder')"
      :name="props.element.tag"
      accept="image/*"
      @click="onInputClick"
    />

    <div
      v-else-if="'url' in props.element"
      class="form-builder--item form-builder--image"
      :align="!props.element.align ? 'center' : props.element.align"
    >
      <img
        :src="props.element.url"
        :alt="props.element.alt"
        :style="{
          width:
            !props.element.width || props.element.width <= 0 ? '100%' : props.element.width + 'px',
          height:
            !props.element.height || props.element.height <= 0
              ? '100%'
              : props.element.height + 'px',
        }"
      />
    </div>
  </div>
</template>
